// src/App.jsx
import React, { useState, useEffect, useRef } from 'react';
import './App.css';

import Header from './components/Header/Header';
import HeroSection from './components/HeroSection';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import Projects from './components/Projects';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import LoadingScreen from './components/LoadingScreen';

function App() {
  const [loading, setLoading] = useState(true);
  const aboutRef = useRef(null); // ✅ top of component
  const servicesRef = useRef(null); // ✅ Add this

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  const scrollToAbout = () => {
    if (aboutRef.current) {
      aboutRef.current.scrollIntoView({ behavior: 'smooth' });
      
    }
  };
  const scrollToServices = () => {
    if (servicesRef.current) {
      servicesRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div className="App">
      <Header onAboutClick={scrollToAbout} />
      <HeroSection />
      <AboutUs ref={aboutRef} /> {/* Pass ref here */}
      <Services />
      <Projects />
      <Testimonials />
      <Footer />
    </div>
    
  );
}

export default App;
